import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VoohCampaignsFiltersForm, voohFiltersFormDefault } from './types'

export interface CampaignTableFiltersState {
  voohCampaignfilters: VoohCampaignsFiltersForm
  collapsed: boolean
  loading: boolean
}

const initialState: CampaignTableFiltersState = {
  voohCampaignfilters: voohFiltersFormDefault,
  collapsed: true,
  loading: true,
}

export const voohCampaignTableFiltersSlice = createSlice({
  name: 'voohCampaignTableFilters',
  initialState,
  reducers: {
    setVoohCampaignsFilters: (state, action: PayloadAction<VoohCampaignsFiltersForm>) => {
      state.voohCampaignfilters = action.payload
    },
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    resetFilters: () => {
      return initialState
    },
  },
})

export const { setVoohCampaignsFilters, setCollapsed, setLoading, resetFilters } =
  voohCampaignTableFiltersSlice.actions
export const voohCampaignTableFiltersReducer = voohCampaignTableFiltersSlice.reducer
